import { Provider } from '@angular/core'
import { GameSetupConfig, GameSetupPlayerService } from 'game-setup-services'
import { gameSetupConfigToken } from './game-setup-config.token'

export const gameSetupPlayerServiceProvider: Provider = {
  provide: GameSetupPlayerService,
  useFactory: (gameSetupConfig: GameSetupConfig): GameSetupPlayerService => {
    return new GameSetupPlayerService(gameSetupConfig)
  },
  deps: [gameSetupConfigToken],
}
